export default __webpack_public_path__ + "static/media/remodelSide.36670eb3.png";